import Axios from 'axios';
import React, { Component } from 'react';
import * as storage from '../storage';
import { Response } from '../types';
import CookieNoticeBanner from './CookieNoticeBanner';

const API_URL = '/api/cookie-notice-message';

interface Props { }

interface State {
    /**
     * Whether the notice is enabled or not
     * False by default, but the api will be queried to enable it if needed
     */
    enabled: boolean;
}

export default class CookieNoticeBannerContainer
extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.handleAccept = this.handleAccept.bind(this);
        this.state = { enabled : false };
        if (!storage.getCookiesAccepted()) {
            this.load();
        }
    }

    public async load() {
        const response = await Axios.get<Response>(API_URL);
        this.setState({ enabled: response && response.data.enabled });
    }

    public handleAccept() {
        storage.setCookiesAccepted(true);
        this.forceUpdate();
    }

    public render() {
        const { handleAccept} = this;
        const { enabled } = this.state;

        if (!enabled) {
            return null;
        }

        return <CookieNoticeBanner
            onAccept={handleAccept}
            accepted={storage.getCookiesAccepted()} />
        ;
    }
}
